import axios from 'axios';

/**
 * Uploads a file directly to Cloudinary using a signed request from our backend.
 * This bypasses Vercel's 4.5MB payload limit.
 * @param {File} file 
 * @returns {Promise<string>} The URL of the uploaded file
 */
export const uploadToCloudinary = async (file) => {
  try {
    // 1. Get signature from our backend
    const { data } = await axios.get('/api/media/signature');
    const { signature, timestamp, cloud_name, api_key } = data;

    // 2. Prepare Form Data for Cloudinary
    const formData = new FormData();
    formData.append('file', file);
    formData.append('signature', signature);
    formData.append('timestamp', timestamp);
    formData.append('api_key', api_key);
    formData.append('folder', 'villa-tesori');

    // 3. Upload to Cloudinary API directly
    const uploadUrl = `https://api.cloudinary.com/v1_1/${cloud_name}/auto/upload`;
    
    // Create a clean axios instance for Cloudinary to avoid CORS issues with our global auth headers
    const cloudinaryAxios = axios.create();
    
    const response = await cloudinaryAxios.post(uploadUrl, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        console.log(`Cloudinary Upload: ${percentCompleted}%`);
      }
    });

    return response.data.secure_url;
  } catch (error) {
    if (error.response?.status === 401) {
      throw new Error('Your session has expired. Please log out and log in again to upload.');
    }
    console.error('Direct Cloudinary Upload Failed:', error.response?.data || error.message);
    throw new Error('Upload failed. Please try a smaller file or check your connection.');
  }
};
